export default "__VITE_ASSET__DU_zx6P2__"